import { Device } from 'medialoopster/modules';

export default (device: Device, hasSuperUserRight = true): string =>
  hasSuperUserRight ? `[${device.name}] ${device.display_name}` : `${device.display_name}`;
